import script from "./NewsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsView.vue?vue&type=script&setup=true&lang=ts"

import "./NewsView.vue?vue&type=style&index=0&id=77f76a4d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f76a4d"]])

export default __exports__